module.exports = __webpack_public_path__ + "img/place_empty.288ae954.png";